// React
import React, { useRef, useEffect } from "react";
// React
// CSS
import styles from "./PlaybackModal.module.css";
// CSS
// Models
import HelperHeader from "../../../Utils/HelperHeader/HelperHeader";
// Models

type PlayBackModalProps = {
  setIsPlayBackSpeedModalInScreen: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  setPlayBackSpeed: (data: number) => void;
};

const PlayBackModal: React.FunctionComponent<PlayBackModalProps> = ({
  setIsPlayBackSpeedModalInScreen,
  setPlayBackSpeed,
}) => {
  const outerRef = useRef<HTMLDivElement>(null);
  const innerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setTimeout(() => {
      if (!outerRef.current) return;
      if (!innerRef.current) return;
      outerRef.current.style.opacity = "1";
      innerRef.current.style.top = "0";
    }, 50);
  }, []);

  const closeModal = () => {
    if (!outerRef.current) return;
    if (!innerRef.current) return;
    outerRef.current.style.opacity = "0";
    innerRef.current.style.top = "80vh";
    setTimeout(() => {
      setIsPlayBackSpeedModalInScreen(false);
    }, 500);
  };

  return (
    <div
      className={`${styles.modalContainer} fixed top-0 ${
        window.innerWidth > 600 ? "left-auto" : "left-0"
      } w-screen h-screen flex items-center justify-center z-[300]`}
    >
      <div
        className={`${styles.outer} absolute z-[400] w-screen h-screen `}
        onClick={() => {
          if (!outerRef.current) return;
          if (!innerRef.current) return;
          outerRef.current.style.opacity = "0";
          innerRef.current.style.top = "120vh";

          setTimeout(() => {
            setIsPlayBackSpeedModalInScreen(false);
          }, 500);
        }}
        ref={outerRef}
      ></div>
      <div
        className={`${styles.inner} relative z-[500] flex flex-col  items-center bg-white w-10/12 p-4 overflow-y-scroll rounded-xl`}
        ref={innerRef}
      >
        <HelperHeader absoluteText="تنظـــیم سرعــت پـــخش" isBgWhite={true} />
        <button
          onClick={() => {
            setPlayBackSpeed(50);
            closeModal();
          }}
          className="mt-8"
        >
          x 0.5
        </button>
        <button
          onClick={() => {
            setPlayBackSpeed(100);
            closeModal();
          }}
          className="mt-2"
        >
          x 1
        </button>
        <button
          onClick={() => {
            setPlayBackSpeed(150);
            closeModal();
          }}
          className="mt-2"
        >
          x 1.5
        </button>
        <button
          onClick={() => {
            setPlayBackSpeed(200);
            closeModal();
          }}
          className="mt-2"
        >
          x 2.0
        </button>
      </div>
    </div>
  );
};

export default PlayBackModal;
